import React from "react";
import Button from "antd/lib/button";
import Upload from "antd/lib/upload";
import UploadOutlinedIcon from "@ant-design/icons/UploadOutlined";
import { useTheme } from "@/components/ThemeProvider";

export default function FileField({ form, field, ...otherProps }) {
  const { name, initialValue } = field;
  const { getFieldValue } = form;
  const disabled = getFieldValue(name) !== undefined && getFieldValue(name) !== initialValue;
  const { isDarkMode } = useTheme();

  return (
    <Upload {...otherProps} beforeUpload={() => false} className={isDarkMode ? "dark-mode" : ""}>
      <Button disabled={disabled} className={isDarkMode ? "dark-mode" : ""}>
        <UploadOutlinedIcon /> Click to upload
      </Button>
    </Upload>
  );
}
